import { render, staticRenderFns } from "./DGEntryPop.vue?vue&type=template&id=c5b85d20"
import script from "./DGEntryPop.vue?vue&type=script&lang=js"
export * from "./DGEntryPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5b85d20')) {
      api.createRecord('c5b85d20', component.options)
    } else {
      api.reload('c5b85d20', component.options)
    }
    module.hot.accept("./DGEntryPop.vue?vue&type=template&id=c5b85d20", function () {
      api.rerender('c5b85d20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/DGEntryPop.vue"
export default component.exports